
import { Box, useMediaQuery } from "@mui/material";
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import theme from "../../theme/theme";
import * as Styled from "./PWAModal.styles"
import CloseIcon from '@mui/icons-material/Close'

interface PWABannerProps {
    onClose: any;
    openModal: any;
}

const PWABanner = ({ onClose, openModal }: PWABannerProps) => {
    const isDesktop = useMediaQuery((theme: any) =>
        theme.breakpoints.up("desktop")
      );

    const desktopBanner = (): JSX.Element => {
        return (

            <Box padding="16px 12px" display="flex" justifyContent="space-between" sx={{ backgroundColor: theme.colors.secondary.lightGray }}>
                <Box display="flex" alignItems="center" >
                    <AddToHomeScreenIcon sx={{ color: theme.colors.primary.slalomBlue }} />
                    <Styled.DesktopBannerPrimaryText sx={{
                        paddingLeft: "8px"
                    }}>Add Gather to Your Home Screen </Styled.DesktopBannerPrimaryText>
                    <Styled.DesktopSubtitleActionText sx={{paddingLeft: "12px"}} variant="modalSubtitle"
                        onClick={openModal}
                    >View Instructions</Styled.DesktopSubtitleActionText>
                </Box>
                <Box display="flex">
                    
                    <Styled.CloseModalButton onClick={onClose}>
                        <CloseIcon />
                    </Styled.CloseModalButton>

                </Box>
            </Box>
        )
    }

    const mobileBanner = (): JSX.Element => {

       return ( <Box padding="16px 12px" display="flex" justifyContent="space-between" sx={{ backgroundColor: theme.colors.secondary.lightGray }}>
                <Box display="flex" alignItems="center" >
                    <AddToHomeScreenIcon sx={{ color: theme.colors.primary.slalomBlue }} />
                    <Styled.MobileBannerPrimaryText sx={{
                        paddingLeft: "8px"
                    }}>
                        Add Gather to Your Home Screen 
                    </Styled.MobileBannerPrimaryText>
                    
                </Box>
                <Box display="flex">
                    <Styled.MobileSubtitleActionText  variant="modalSubtitle"
                        onClick={openModal}
                    >View</Styled.MobileSubtitleActionText>
                    <Styled.CloseModalButton onClick={onClose}>
                        <CloseIcon />
                    </Styled.CloseModalButton>

                </Box>
            </Box> )
    }

    return (
        <>
        { isDesktop ? desktopBanner() : mobileBanner()  }
        </>
    )
}

export default PWABanner;